import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import rulePopout from 'components/triggers/RulePopout';
import LibraryStore from 'stores/library/LibraryStore';
import {LibraryAccessType} from 'records/FeedbackTrigger';
import LibraryActions from 'actions/library/LibraryActions';
import LibraryContextSelect from './LibraryContextSelect';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import FlatButton from 'components/pure/utils/FlatButton';

class LibraryContextSelectContainer extends React.Component {
  constructor(props) {
    super(props);

    this.selectedContextTypeChanged = this.selectedContextTypeChanged.bind(this);
    this.selectedValueChanged = this.selectedValueChanged.bind(this);
    this.saveSelection = this.saveSelection.bind(this);

    this.state = {
      selectedContextType: null,
      selectedValue: null,
      selectedOption: null,
    };
  }

  static getStores() {
    return [LibraryStore];
  }

  static getPropsFromStores() {
    const tags = LibraryStore.getState().sources.get('tags') || [];
    const libraries = LibraryStore.getState().sources.get('libraries') || [];

    const tagOptions = tags.map(tag => {
      return {label: tag, value: tag};
    });
    const libraryOptions = libraries.map(lib => {
      return {label: lib.name, value: lib.id};
    });

    return {tagOptions, libraryOptions};
  }

  saveSelection(type, value, option) {
    this.props.saveSelection({type, value, option});
  }

  selectedContextTypeChanged(context) {
    this.setState({
      selectedValue: null,
      selectedOption: null,
      selectedContextType: context,
    });
    if (
      this.props.closeOnSelect &&
      (context === LibraryAccessType.LIBRARY_I_CAN_VIEW ||
        context === LibraryAccessType.LIBRARY_I_CREATED ||
        context === LibraryAccessType.LIBRARY_I_ADMIN ||
        context === LibraryAccessType.ANY_LIBRARY)
    ) {
      this.saveSelection(context, null, null);
    }
  }
  selectedValueChanged(value, option) {
    this.setState({
      selectedValue: value,
      selectedOption: option,
    });
    if (this.props.closeOnSelect) {
      this.saveSelection(this.state.selectedContextType, value, option);
    }
  }

  componentDidMount() {
    const tags = LibraryStore.getState().sources.get('tags');
    const libraries = LibraryStore.getState().sources.get('libraries');

    if (tags === null || tags === undefined) {
      LibraryActions.getTags();
    }

    if (libraries === null || libraries === undefined) {
      LibraryActions.getLibraries();
    }

    this.setState({
      selectedValue: this.props.selectedValue,
      selectedContextType: this.props.selectedContextType,
    });
  }

  render() {
    const {selectedContextType, selectedValue, selectedOption} = this.state;
    const canSave =
      [
        LibraryAccessType.LIBRARY_I_CAN_VIEW,
        LibraryAccessType.LIBRARY_I_CREATED,
        LibraryAccessType.LIBRARY_I_ADMIN,
        LibraryAccessType.ANY_LIBRARY,
      ].includes(selectedContextType) ||
      (selectedContextType && selectedValue);
    return (
      <div className="rule-select-popup">
        <LibraryContextSelect
          {...this.props}
          selectedContextType={selectedContextType}
          selectedValue={selectedValue}
          selectedContextTypeChanged={this.selectedContextTypeChanged}
          selectedValueChanged={this.selectedValueChanged}
        />
        <div className="selection-buttons">
          <button
            className={canSave ? 'save' : 'save disabled'}
            disabled={!canSave}
            onClick={() => this.saveSelection(selectedContextType, selectedValue, selectedOption)}>
            <CheckIcon color={canSave ? 'white' : 'gray'} />
          </button>
          <FlatButton onClick={() => this.props.closeRequest('cancel')}>Cancel</FlatButton>
        </div>
      </div>
    );
  }
}

export default rulePopout(connectToStores(LibraryContextSelectContainer));
